import React, { useEffect, useState } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import { db } from './../../../../firebase';
import noDataFound from '../../../../assets/images/icons/no-data-found.png';
import { useAuth } from '../../../../context/AuthContext';
import TotalOutstanding from './total-outstanding';

const BookingWidget = () => {

  const navigate = useNavigate();

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "Businesses", bid, "Bookings"), orderBy('createdOn'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }, []);

  return (
    <div className='datatable'>
      <table className='table'>
        {
          data && data.length > 0 ?
            <>
              <thead className='table-head sticky-top'>
                <tr>
                  <th className='text-start'>Booking ID</th>
                  <th className='text-start'>Party Name</th>
                  <th className='text-start'>Property</th>
                  <th className='text-start'>Category</th>
                  <th className='text-end'>Outstanding</th>
                </tr>
              </thead>
              <tbody>
                {
                  data && data.map((tb_items, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className="align-middle cursor-pointer text-primary"
                          onClick={() => navigate('/admin/bookings/details', { state: { ...tb_items } })}
                        >
                          {tb_items.id}
                        </td>
                        <td className="align-middle">{tb_items.partyDetails.partyName}</td>
                        <td className="align-middle">{tb_items.projectDetails.propName}</td>
                        <td className="align-middle">{tb_items.projectDetails.bookedUnit.unitName}</td>
                        <td className="align-middle text-end">
                          <TotalOutstanding bookingID={tb_items.id} />
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </>
            :
            <tbody>
              <tr className='no-data-found bg-white'>
                <td className='text-center bg-primary-light rounded w-100 m-3' colSpan={4}>
                  <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                  <span>No Bookings Found</span>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default BookingWidget;
